<template>
  <table class="ArticleTable">
    <tr>
      <th v-for="({ name }, index) in columns" :key="index">
        {{ name }}
      </th>
    </tr>
    <ArticleProgress
      v-for="(article, index) in articles"
      :key="article.id"
      :article="article"
      :class="{ alt: index % 2 }"
      :columns="columnsSections"
      :isSelected="idsSelected.includes(article.id)"
      @select="setSelected(article.id, $event)" />
  </table>
</template>

<script>
import {
  filter, groupBy, head, indexBy, map, nth, objOf, pipe, pluck, prop, sortBy, toPairs,
} from 'rambda'
import ArticleProgress from './ArticleProgress'
import { average } from '@utils/numbers'
import { getters } from '@utils'
import { isNotNil } from '@utils/guards'
import { toggleItem } from '@utils/collections'

export default {
  components: {
    ArticleProgress,
  },
  props: {
    articles: Array,
    idsSelected: Array,
  },
  computed: {
    columns() {
      const wrapInName = objOf('name')

      return [
        ...this.$ta('columnsPersistentHead').map(wrapInName),
        ...this.columnsSections,
        ...this.$ta('columnsPersistentTail').map(wrapInName),
      ]
    },
    columnsSections() {
      const sectionTemplatesById = indexBy(prop('id'), this.sectionTemplates)

      return this
        .sectionTemplateIdsSorted
        .map(sectionTemplateId => ({
          name: sectionTemplatesById[sectionTemplateId].name,
          sectionTemplateId,
        }))
    },
    sectionTemplates() {
      return this.query('sectionTemplate')
    },
    sectionTemplateIdsSorted() {
      return pipe(
        this.query,
        groupBy(prop('sectionTemplateId')),
        map(pipe(
          pluck('position'),
          filter(isNotNil),
          average,
        )),
        toPairs,
        sortBy(nth(1)),
        map(pipe(head, Number)),
      )('section')
    },
    ...getters(),
  },
  methods: {
    setSelected(articleId, isSelected) {
      const idsSelected = toggleItem(articleId, this.idsSelected)

      this.$up('idsSelected', idsSelected)
    },
  },
}
</script>

<style lang="scss">
.ArticleTable {
  margin-top: $grid-unit * 2;
  text-align: left;
  width: 100%;

  .ArticleProgress.alt {
    background: $white-bis;
  }

  > tr.ArticleProgress {
    &:hover {
      background: $grey-lightest;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "columnsPersistentHead": [
      "Site",
      "Topic",
      "Category",
      "Status",
      ""
    ],
    "columnsPersistentTail": [
      "Laptops",
      ""
    ]
  }
}
</i18n>
